{
  "fr": {
    "aiFeedback": {
      "confirm": {
        "deleteFeedback": {
          "text": "Cette action est irréversible. Le feedback et tous les résultats associés seront supprimés.",
          "title": "Supprimer le feedback ?"
        },
        "deleteResult": {
          "text": "Cette action est irréversible. Le résultat et le feedback associé seront définitivement supprimés.",
          "title": "Supprimer le résultat ?"
        }
      },
      "criteria": {
        "contentAccuracy": "Le sujet est développé de manière appropriée à la question posée et inclut des chiffres, données et faits corrects sur le sujet.",
        "spellingAndGrammar": "L'orthographe, la formation des mots et la construction des phrases sont grammaticalement correctes. Les mots de contenu, les mots fonctionnels, les expressions complexes et les termes techniques sont utilisés de manière appropriée.",
        "structureAndOrganization": "Le texte révèle une idée globale appropriée au sujet, est structuré de manière cohérente et montre une organisation interne/externe, par exemple à travers des sections."
      },
      "deprecationAlert": {
        "title": "Cet outil est masqué par défaut",
        "description": "Il peut être activé au niveau de l'école sur demande.",
        "learnMoreLink": "En savoir plus"
      },
      "unlockedAlert": {
        "title": "Cet outil est activé pour votre école",
        "description": "Il n'est plus développé, mais reste utilisable pour votre école.",
        "learnMoreLink": "En savoir plus"
      },
      "defaults": {
        "name": "Nouvelle correction"
      },
      "emptyState": {
        "heading": "Aucune correction disponible",
        "text": "Créez une nouvelle correction en insérant le texte original et en définissant les critères."
      },
      "flash": {
        "feedbackResultUpdated": "Feedback mis à jour",
        "feedbackUpdated": "Critères mis à jour",
        "textExtractionSuccess": "Extraction de texte réussie"
      },
      "headings": {
        "feedback": "Proposition de correction",
        "form": "Définir les critères",
        "goodToKnow": "Bon à savoir",
        "input": "Texte original",
        "text": "Entrer le texte"
      },
      "hints": {
        "dropFileImage": "Glissez simplement une image avec du contenu textuel ou",
        "dropFilePdf": "Glissez un PDF ici ou",
        "experimental": "L'outil d'aide à la correction génère des <strong>propositions pour une pré-correction</strong> des travaux des élèves. Pour interpréter et utiliser ces propositions de manière responsable, il est impératif de prendre connaissance et de respecter les <strong>conditions et limitations recommandées de l'IA</strong>. <a href='https://app.fobizz.com/de/help/articles/249-korrekturhilfe-tool-ki' target='_blank'>En savoir plus</a>",
        "fileLimit": "max {size}MB, {types}",
        "imageRecognitionInProgress": "Reconnaissance d'image en cours...",
        "pdfRecognitionInProgress": "Extraction de texte en cours..."
      },
      "info": {
        "result": {
          "heading": "Bon à savoir :",
          "text": "Les réponses de l'IA doivent être comprises comme des <strong>propositions</strong>. Elles ne peuvent jamais remplacer une évaluation didactique fondée des travaux des élèves."
        }
      },
      "infoMessages": {
        "criteria": "Définissez les critères sur lesquels l'IA doit baser son feedback. Plus vous formulez précisément les critères, plus le feedback sera précis."
      },
      "labels": {
        "addCriteria": "Ajouter un critère",
        "assignment": "Consigne",
        "criteria": "Critères d'évaluation",
        "input": "Texte original",
        "inputMethod": "Méthode de saisie",
        "name": "Abréviation (pas de nom complet), par exemple année plus numéro de la liste de classe",
        "solution": "Horizon d'attente ou solution modèle"
      },
      "links": {
        "evaluateText": "Corriger le texte",
        "new": "Nouvelle correction",
        "pastAssessments": "Corrections passées",
        "useFile": "Utiliser le texte de l'image",
        "usePdf": "Utiliser le texte du PDF",
        "useText": "Insérer le texte original"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/de/help/articles/249-korrekturhilfe-tool-ki",
          "text": "L'outil d'aide à la correction génère des <strong>propositions pour une pré-correction</strong> des travaux des élèves. Pour interpréter et utiliser ces propositions de manière responsable, il est impératif de prendre connaissance et de respecter les <strong>conditions et limitations recommandées de l'IA</strong>.",
          "title": "Conseils pour l'utilisation de l'outil d'aide à la correction"
        }
      },
      "paragraphs": {
        "create": "Gagnez un temps précieux lors de la correction grâce à la correction d'erreurs et aux propositions d'évaluation assistées par IA.",
        "goodToKnow": "Les réponses de l'IA doivent être comprises comme des <strong>propositions</strong>. Elles ne peuvent jamais remplacer une évaluation didactique fondée des travaux des élèves."
      },
      "placeholders": {
        "assignment": "Écrivez un court essai sur les principales causes et événements historiques de la Révolution française.",
        "input": "Insérer le texte ici...",
        "name": "4c-17",
        "solution": "Solution modèle :\nRévolution française La R. F. de 1789 est considérée comme l'un des tournants politico-sociaux les plus importants de l'histoire européenne. Elle a aboli la domination absolutiste et les privilèges de la noblesse et de l'église, remplaçant ceux-ci par la classe bourgeoise. Les causes de la R. F. étaient des problèmes sociaux et économiques profonds (famines, insolvabilité de l'État). L'élément central de la R. F. était l'Assemblée nationale française, qui a adopté en 1789 la Déclaration des droits de l'homme et du citoyen. En 1793, les objectifs de la R. F. ont été résumés par les slogans de liberté, égalité, fraternité (Liberté, Égalité, Fraternité), qui ont été diffusés bien au-delà de la France et ont eu des répercussions dans presque tous les États européens. L'interdiction du slogan dans les provinces rhénanes prussiennes a encore des effets aujourd'hui dans le carnaval bourgeois et le nombre magique ELF (Égalité, Liberté, Fraternité), qui n'a pas pu être interdit : Pourquoi sinon le soulèvement des fous (= citoyens) commencerait-il toujours le 11.11 à 11h11 ?\nSource : Schubert, Klaus/Martina Klein : Das Politiklexikon. 7., aktual. u. erw. Aufl. Bonn : Dietz 2020. Lizenzausgabe Bonn : Bundeszentrale für politische Bildung."
      },
      "sampleText": "Yo, mec ! La Révolution française était une période de ouf, de 1789 à 1799. Les gens en avaient marre des nobles et du roi qui se la coulaient douce pendant que le peuple crevait de faim. Alors ils ont dit : \"Ça suffit, mec !\" et ont viré le roi et les nobles. C'était la fin de la monarchie et le début de la première république en France. Mais tout n'était pas cool, il y a eu beaucoup de sang versé, surtout pendant la \"Terreur\". Mais au final, cette révolution a changé le monde et a diffusé des idées comme la liberté, l'égalité et la fraternité. Totalement dingue, non ?"
    }
  }
}
